import { POSTHOG_FEATURES } from "../constants/feature-flags"
import usePostHogFeatureFlags from "./posthog-feaures"

/**
 * Gate for the AdBlaster → Partnerships tab (MD-5524). Mirrors
 * `useAdForgeAccess`: a single PostHog flag, no company-level rule.
 */
export default function usePartnershipTrackerAccess() {
  const isFeatureFlagEnabled = usePostHogFeatureFlags(
    POSTHOG_FEATURES.PARTNERSHIP_TRACKER_ENABLED,
  )

  return { hasAccess: isFeatureFlagEnabled }
}
